// In your app.module.ts file

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormBuilder, FormsModule, NG_VALIDATORS } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';

import { ComponentsModule } from './components/components.module';
import { ExamplesModule } from './examples/examples.module';
import { HomeComponent } from './home/home.component';
import { SelfDeclarationComponent } from './self-declaration/self-declaration.component';
import { ProfessionalServicesComponent } from './professional-services/professional-services.component';
import { QuestionsComponent } from './questions/questions.component';
import { NgWizardModule, NgWizardConfig, THEME } from 'ng-wizard';
import { DndDirective } from './file-upload/dnd.directive';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { BlockUIModule } from 'ng-block-ui';
import { FinishComponent } from './finish/finish.component';
import { ErrorComponent } from './error/error.component';
import { SubmittedComponent } from './submitted/submitted.component';
import { ExpiredComponent } from './expired/expired.component';
import { NotAvailableComponent } from './not-available/not-available.component';
import { PharmacyRegistrationComponent } from './pharmacy-registration/pharmacy-registration.component';
import { PharmacyOwnerNgbdModalContent } from './pharmacy-registration-owner/pharmacy-registration-owner.component';
// IMPORT THE STAFF MODAL COMPONENT
import { PharmacyStaffNgbdModalContent } from './pharmacy-staff-modal/pharmacy-staff-modal.component';
import { RegistrationCompletedComponent } from './registration-completed/registration-completed.component';
import { AbnValidatorDirective } from './shared/abn-validator.directive';
import { AllOwnerConfirmComponent } from './all-owner-confirm/all-owner-confirm.component';
import { ConfirmSelectionComponent } from './confirm-selection/confirm-selection.component';

const ngWizardConfig: NgWizardConfig = {
  theme: THEME.arrows
};

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    SelfDeclarationComponent,
    ProfessionalServicesComponent,
    ConfirmSelectionComponent,
    QuestionsComponent,
    DndDirective,
    FileUploadComponent,
    FinishComponent,
    ErrorComponent,
    SubmittedComponent,
    ExpiredComponent,
    NotAvailableComponent,
    PharmacyRegistrationComponent,
    PharmacyOwnerNgbdModalContent,
    // ADD THE STAFF MODAL COMPONENT HERE
    PharmacyStaffNgbdModalContent,
    RegistrationCompletedComponent,
    AbnValidatorDirective,
    AllOwnerConfirmComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    NgbModalModule,
    FormsModule,
    RouterModule,
    ComponentsModule,
    ExamplesModule,
    AppRoutingModule,
    NgWizardModule.forRoot(ngWizardConfig),
    BlockUIModule.forRoot(),
    HttpClientModule,
  ],
  entryComponents:[
    PharmacyOwnerNgbdModalContent,
    // ADD THE STAFF MODAL COMPONENT HERE TOO
    PharmacyStaffNgbdModalContent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }